import { render, staticRenderFns } from "./youthSs.vue?vue&type=template&id=04ef2126&scoped=true&"
import script from "./youthSs.vue?vue&type=script&lang=js&"
export * from "./youthSs.vue?vue&type=script&lang=js&"
import style0 from "./youthSs.vue?vue&type=style&index=0&id=04ef2126&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef2126",
  null
  
)

export default component.exports